import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=57db52b6&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57db52b6')) {
      api.createRecord('57db52b6', component.options)
    } else {
      api.reload('57db52b6', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=57db52b6&", function () {
      api.rerender('57db52b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-manage/menu-manage/menu.vue"
export default component.exports